import styled from 'styled-components';

export const PreviewContainer = styled.div`
  padding: 20px 64px;
  background-coor: #e4eaf0;
  text-align: center;
  display: flex;
  width: 100%;
  min-width: 360px;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
